import {Jurisdiction} from '@/utils/countries/constants'

export const AI_SUGGESTION_RESOLVE_DIRECTIVE = 'Resolve the thread'

export enum ApplicationDraftSubmitOptionType {
  review = 'review',
  approved = 'approved',
}

export enum ApplicationDraftFilingBasisScenario {
  useInCommerce = 'Use in commerce',
  intentToUse = 'Intent to use',
  foreignRegistrationBasis = 'Foreign registration basis',
}

export enum ApplicationDraftSectionCommentThreadID {
  registrationEntity = 'registration_entity',
  legalRepresentative = 'legal_representative',
  trademarkInfo = 'trademark_info',
  goodsAndServices = 'goods_and_services',
  useInCommerce = 'use_in_commerce',
  specimens = 'specimens',
  additionalInfo = 'additional_info',
  documents = 'documents',
  priorityFiling = 'priority_filing',
  mailingAddress = 'mailing_address',
  domicileAddress = 'domicile_address',
}

// List of countries that prefers figurative TMs in black and white
export const bwLogoPreference = [
  Jurisdiction.US,
  Jurisdiction.CA,
  Jurisdiction.CN,
  Jurisdiction.JP,
  Jurisdiction.SG,
  Jurisdiction.HK,
  Jurisdiction.IN,
  Jurisdiction.DE,
  Jurisdiction.NZ,
  Jurisdiction.CH,
]

export const applicationDraftMaxFileSize = 10 * 1024 * 1024
export const applicationDraftDocumentMaxFiles = 1
export const applicationDraftSpecimenMaxFiles = 15
export const applicationDraftLogoVersionMaxFiles = 8

export const supportedRenderingFormats = ['png', 'jpeg', 'jpg', 'bmp', 'gif', 'svg', 'pdf']
